var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.userHasPermissions("provider.practitioner.specialty.view")
    ? _c(
        "div",
        [
          _c("section-title", {
            attrs: { content: "Información de Especialidad", "has-line": true }
          }),
          _vm.value.length > 0
            ? _c(
                "div",
                { staticClass: "specialty-information-list mt-3" },
                [
                  _vm._l(_vm.value, function(specialty, idx) {
                    return _c(
                      "callout",
                      {
                        key: idx,
                        staticClass: "mb-2",
                        attrs: {
                          "has-toggle": false,
                          opened:
                            !_vm.disabled &&
                            _vm.editMode &&
                            _vm.editInfo.data != null &&
                            _vm.editInfo.index == idx
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.editMode && _vm.editInfo.index == idx
                              ? {
                                  key: "edition",
                                  fn: function() {
                                    return [
                                      _c("specialty-information-add-edit", {
                                        attrs: {
                                          "custom-error-message":
                                            _vm.addEditCustomErrorMessage,
                                          "used-specialties":
                                            _vm.existingSpecialties
                                        },
                                        on: {
                                          "on-cancel": _vm.onSpecialtyCanceled,
                                          "on-saved": _vm.onSpecialtySaved
                                        },
                                        model: {
                                          value: _vm.editInfo.data,
                                          callback: function($$v) {
                                            _vm.$set(_vm.editInfo, "data", $$v)
                                          },
                                          expression: "editInfo.data"
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              : null
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c("div", { staticClass: "row mt-2 mb-2" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-12 col-md-2 col-lg-2 cell sd"
                            },
                            [
                              _c("div", { staticClass: "data ml-3" }, [
                                _c("p", { staticClass: "bold" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(specialty.practitionerTypeName) +
                                      " "
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-12 col-md-4 col-lg-4 cell ml-3 ml-md-0 ml-sm-3"
                            },
                            [
                              _c("div", { staticClass: "data" }, [
                                _c("span", [_vm._v("Universidad:")]),
                                _c("p", [_vm._v(_vm._s(specialty.collegeName))])
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-12 col-md-2 col-lg-2 cell ml-3 ml-md-0 ml-sm-3"
                            },
                            [
                              _c("div", { staticClass: "data" }, [
                                _c("span", [_vm._v("Fecha Desde:")]),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm._f("date")(specialty.startDate))
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-sm-12 col-md-2 col-lg-2 cell ml-3 ml-md-0 ml-sm-3"
                            },
                            [
                              _c("div", { staticClass: "data" }, [
                                _c("span", [_vm._v("Fecha Hasta:")]),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm._f("date")(specialty.endDate))
                                  )
                                ])
                              ])
                            ]
                          ),
                          !_vm.disabled && _vm.canPerformActions
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-12 col-md-2 col-lg-2 cell actions ml-3 ml-md-0 ml-sm-3"
                                },
                                [
                                  _c("drop-down", {
                                    attrs: {
                                      "data-item": idx,
                                      items: _vm.getAvailableActions(
                                        specialty,
                                        idx
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _c("div", { staticClass: "splitter" }, [
                          _c("div", { staticClass: "col-sm-12" })
                        ]),
                        _c("div", { staticClass: "row mt-2 mb-2" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-12 col-md-2 cell" },
                            [
                              _c("div", { staticClass: "data ml-3" }, [
                                _c("span", [_vm._v("Especialidad:")]),
                                _c("p", [
                                  _vm._v(_vm._s(specialty.specialtyTypeName))
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-10 col-sm-12 cell ml-3 ml-md-0 ml-sm-3"
                            },
                            _vm._l(specialty.disciplineTypes, function(
                              disciplineType
                            ) {
                              return _c(
                                "div",
                                {
                                  key: disciplineType.id,
                                  staticClass: "badge"
                                },
                                [_c("p", [_vm._v(_vm._s(disciplineType.name))])]
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    )
                  }),
                  !_vm.disabled
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _vm.editInfo.data == null && _vm.canAddSpecialty
                              ? _c(
                                  "action-button",
                                  {
                                    staticClass: "float-right",
                                    attrs: {
                                      i: "fas fa-file-plus",
                                      variant: "success"
                                    },
                                    on: { click: _vm.newSpecialty }
                                  },
                                  [_vm._v(" Añadir ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            : _c(
                "div",
                { staticClass: "specialty-information-list mt-3" },
                [
                  _vm.value.length == 0 &&
                  _vm.canAddSpecialty &&
                  _vm.editInfo.data == null &&
                  !_vm.disabled
                    ? _c(
                        "callout",
                        {
                          attrs: {
                            "class-main":
                              "py-0 py-md-3 py-sm-0 px-4 px-md-0 px-sm-4",
                            "has-toggle": false
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row d-flex justify-content-center align-items-center"
                            },
                            [
                              _c("action-button", {
                                staticClass:
                                  "border w-sm-100 w-md-40 mt-4 mt-md-0 mt-sm-4",
                                attrs: {
                                  i: "fas fa-file-plus color-primary-1",
                                  text: "Presione aquí para añadir Especialidad"
                                },
                                on: { click: _vm.newSpecialty }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
          _c("callout", {
            staticClass: "mb-2",
            attrs: {
              "has-toggle": false,
              opened: !_vm.disabled && _vm.createMode,
              "show-container": false
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "edition",
                  fn: function() {
                    return [
                      _c("specialty-information-add-edit", {
                        attrs: {
                          "custom-error-message": _vm.addEditCustomErrorMessage,
                          "used-specialties": _vm.existingSpecialties
                        },
                        on: {
                          "on-cancel": _vm.onSpecialtyCanceled,
                          "on-saved": _vm.onSpecialtySaved
                        },
                        model: {
                          value: _vm.editInfo.data,
                          callback: function($$v) {
                            _vm.$set(_vm.editInfo, "data", $$v)
                          },
                          expression: "editInfo.data"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1330189146
            )
          }),
          _vm.displayErrorMessage
            ? _c("error", {
                attrs: { message: _vm.customErrorMessage, variant: "no-border" }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }